import { mapGetters } from 'vuex'

const defaultImage = require('@/assets/images/img-placeholder.png')
const bannerDefaultImage = require('@/assets/images/banner-placeholder.png')
const buyerMobileBanner = require('@/assets/images/banner-placeholder-mobile.png')

export default {
  computed: {
    ...mapGetters('main', [
      'isMobile'
    ])
  },
  methods: {
    imagesMapping (image, actionName = '') {
      const bannerAction = (actionName === 'banner')
      const bannerDefault = this.isMobile ? buyerMobileBanner : bannerDefaultImage
      if (!image) return { src: bannerAction ? bannerDefault : defaultImage }

      return {
        src: image,
        loading: bannerAction ? bannerDefault : defaultImage,
        error: bannerAction ? bannerDefault : defaultImage
      }
    }
  }
}
